/* motion.js — shared motion runtime (see DESIGN.md).
   Libs loaded before this (defer order): Lenis, Motion One (window.Motion), GSAP + ScrollTrigger.
   Principle: content is visible by default. We only hide+animate when motion is allowed AND Motion loaded,
   so headless renderers / reduced-motion / lib failure all leave the page fully visible. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var Motion = window.Motion; // Motion One UMD global
  var motionOK = !reduce && Motion && typeof Motion.animate === 'function';

  // Native scroll — Lenis smooth-scroll removed (inertia felt laggy/floaty). Reveals + ScrollTrigger use native scroll.
  if (window.gsap && window.ScrollTrigger) { window.gsap.registerPlugin(window.ScrollTrigger); }

  if (!motionOK) return; // page already visible; nothing else to do

  document.documentElement.classList.add('cnc-motion');
  var animate = Motion.animate, inView = Motion.inView, stagger = Motion.stagger;
  var EASE = [0.16, 1, 0.3, 1];

  // Reveal = enhancement only. JS sets the hidden state (so no-JS / crawlers / reduced-motion
  // keep the CSS default of opacity:1), inView animates it in, and a failsafe reveals anything
  // inView never fired for (hidden tabs, headless renderers) so a section can never ship blank.
  var pending = [];
  function hide(el) { el.style.opacity = '0'; el.style.transform = 'translateY(22px)'; pending.push(el); }
  function revealOne(el, delay) {
    var i = pending.indexOf(el); if (i !== -1) pending.splice(i, 1);
    animate(el, { opacity: [0, 1], transform: ['translateY(22px)', 'translateY(0px)'] },
      { duration: 0.7, delay: delay || 0, easing: EASE });
  }

  // single reveals
  document.querySelectorAll('[data-reveal]:not([data-reveal-group] [data-reveal])').forEach(function (el) {
    hide(el);
    inView(el, function () { revealOne(el, parseFloat(el.getAttribute('data-reveal-delay')) || 0); return function () {}; },
      { margin: '-10% 0px' });
  });

  // staggered groups
  document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    var kids = [].slice.call(group.querySelectorAll('[data-reveal]'));
    kids.forEach(hide);
    inView(group, function () {
      kids.forEach(function (el, i) { revealOne(el, i * 0.07); });
      return function () {};
    }, { margin: '-8% 0px' });
  });

  // failsafe — reveal anything still hidden after 1.5s (inView may not fire in headless/hidden tabs)
  setTimeout(function () { pending.slice().forEach(function (el) { revealOne(el, 0); }); }, 1500);

  // headline word-stagger: [data-split] → wrap words, rise in
  document.querySelectorAll('[data-split]').forEach(function (h) {
    if (h.dataset.didSplit) return; h.dataset.didSplit = '1';
    var words = h.textContent.trim().split(/\s+/);
    h.innerHTML = words.map(function (w) { return '<span class="cnc-w" style="display:inline-block;will-change:transform,opacity">' + w + '</span>'; }).join(' ');
    var spans = h.querySelectorAll('.cnc-w');
    animate(spans, { opacity: [0, 1], transform: ['translateY(0.9em)', 'translateY(0)'] },
      { delay: stagger(0.05, { start: 0.05 }), duration: 0.8, easing: EASE });
  });

  // ── GSAP ScrollTrigger signatures — scroll-linked "framer-motion" moments ──
  // Only runs when motion is allowed (we returned early otherwise), so reduced-motion /
  // headless / no-lib users keep the fully-visible static markup with no scroll effects.
  var gsap = window.gsap, ST = window.ScrollTrigger;
  if (gsap && ST) {
    // Hero parallax — the grid + glows drift as the hero scrolls away (depth, not decoration).
    var hero = document.querySelector('.cnc-hero2');
    if (hero) {
      var layers = [['.cnc-hero2__grid', 13], ['.cnc-hero2__glow--a', 28], ['.cnc-hero2__glow--b', -20]];
      layers.forEach(function (l) {
        var el = hero.querySelector(l[0]);
        if (el) gsap.to(el, { yPercent: l[1], ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      });
    }

    // Workflow — draw the progress rail as you scroll the sequence, light each step when reached.
    var flow = document.querySelector('[data-flow]');
    if (flow) {
      var fill = flow.querySelector('[data-flow-fill]');
      if (fill) gsap.fromTo(fill, { scaleY: 0 }, { scaleY: 1, ease: 'none', transformOrigin: 'top',
        scrollTrigger: { trigger: flow, start: 'top 60%', end: 'bottom 78%', scrub: true } });
      [].forEach.call(flow.querySelectorAll('.cnc-flow__step'), function (st) {
        ST.create({ trigger: st, start: 'top 70%',
          onEnter: function () { st.classList.add('is-on'); },
          onEnterBack: function () { st.classList.add('is-on'); } });   // latch on, never flicker off
      });
    }

    // Live-DRO ticker — the "Produce" step shows a plausible cutting readout while in view
    // (dogfoods the cycleCNC machine bridge; RPM nods to the mill's 3200 top speed).
    var dro = document.querySelector('[data-dro]');
    if (dro) {
      var fx = dro.querySelector('[data-dro-x]'), fy = dro.querySelector('[data-dro-y]'),
          fz = dro.querySelector('[data-dro-z]'), fs = dro.querySelector('[data-dro-s]'),
          run = false, t0 = 0;
      var frame = function (now) {
        if (!run) return;
        if (!t0) t0 = now; var e = (now - t0) / 1000;
        if (fx) fx.textContent = (62 + 55 * Math.sin(e * 0.9)).toFixed(3);
        if (fy) fy.textContent = (48 + 40 * Math.cos(e * 0.7)).toFixed(3);
        if (fz) fz.textContent = (-3.2 + 2.6 * Math.sin(e * 1.7)).toFixed(3);
        if (fs) fs.textContent = (3160 + Math.round(30 * Math.sin(e * 3))).toLocaleString('en-US');
        requestAnimationFrame(frame);
      };
      ST.create({ trigger: dro, start: 'top 90%', end: 'bottom 10%',
        onToggle: function (self) { run = self.isActive; if (run) { t0 = 0; requestAnimationFrame(frame); } } });
    }
  }

  window.cncRevealOne = revealOne; // expose for section scripts
})();
